import { Controller } from '@hotwired/stimulus';
import events from 'lib/events';

export default class FreeAttributionSlidedownController extends Controller {
  static targets = ['inner'];

  connect() {
    window.addEventListener(events.show_page.reveal_free_attribution_slidedown, this.reveal);
  }

  disconnect() {
    window.removeEventListener(events.show_page.reveal_free_attribution_slidedown, this.reveal);
  }

  reveal = () => {
    this.element.style.height = `${this.innerTarget.offsetHeight}px`;

    setTimeout(() => {
      this.element.classList.add('is-revealed');
      this.element.style.height = 'auto';
    }, 1000);
  }
}
